// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__DTLYO","title":"LoginForm_title__OI3-N"};